<template>
  <market>
    <loader v-if="loading"></loader>

    <section v-if="!loading" class="gallery">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body feature-card-body">
              <b-tabs content-class="mt-3">
                <b-tab :title="$t('features.extension')" active>
                  <feature-list :items="brawseFeatures"></feature-list>
                </b-tab>
                <b-tab :title="$t('features.activeExtension')">
                  <feature-list :items="installedFeatures"></feature-list>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </section>
  </market>
</template>

<script>
import featuresQuery from '@/api/features/features.gql';

export default {
  name: 'MarketFeatures',
  computed: {
    brawseFeatures() {
      return this.featuresChecked.filter((feature) => !feature.isActive);
    },
    installedFeatures() {
      return this.featuresChecked.filter((feature) => feature.isActive);
    },
    loading() {
      return this.$apollo.queries.features.loading;
    },
    featuresChecked() {
      return (this.features || []).map((f) => {
        return { ...f, isActive: this.hasFeature(f.code) };
      });
    },
  },
  apollo: {
    features: {
      query: featuresQuery,
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        return (queryData || {}).features || [];
      },
      error(e) {
        this.$store.commit('SET_ERROR', e.message);
      },
    },
  },
};
</script>

<style lang="scss">
.feature-card-body {
  @media (max-width: 991px) {
    padding: 0rem !important;
  }
}
</style>
